import classnames from 'classnames';
import type { SyntheticEvent } from 'react';
import { sendAnalyticsEvent } from 'src/lib/googleAnalytics';
import { t } from 'src/lib/player/i18n';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';
import { ReloadButton } from '../ReloadButton';

function preventDefault(event: SyntheticEvent) {
  event.preventDefault();
}

export type SidebarSearchFormProps = {
  searchText: string;
  isSettingsTabActive: boolean;
  onSearchTextChange: (text: string) => void;
  onClose: () => void;
  onSwitchToSearchTab: () => void;
  onToggleSettingsTab: () => void;
  autoReloadEnabled?: boolean;
  isReloading?: boolean;
  onReload?: () => Promise<void>;
};

export function SidebarSearchForm({
  searchText,
  isSettingsTabActive,
  onSearchTextChange,
  onClose,
  onSwitchToSearchTab,
  onToggleSettingsTab,
  autoReloadEnabled = false,
  isReloading = false,
  onReload = async () => {},
}: SidebarSearchFormProps): JSX.Element {
  return (
    <div className="side-bar-search">
      <form className="search-form" onSubmit={preventDefault}>
        <i
          className={classnames('fas', 'fa-chevron-left', 'close-icon')}
          {...onClickGenerator(() => {
            sendAnalyticsEvent('starter-list-close');
            onClose();
          })}
        />
        <i
          className={classnames('fas', 'fa-search', 'search-icon')}
          {...onClickGenerator((event) => {
            event.stopPropagation();
            sendAnalyticsEvent('starter-list-search');
            onSwitchToSearchTab();
          })}
        />
        <i
          className={classnames('fas', 'fa-times', 'clear-icon')}
          style={{ display: searchText === '' ? 'none' : 'block' }}
          {...onClickGenerator(() => {
            sendAnalyticsEvent('starter-list-clear');
            onSearchTextChange('');
          })}
        />
        <input
          placeholder={t('Search...')}
          value={searchText}
          onChange={(event) => onSearchTextChange(event.target.value)}
          {...onClickGenerator(onSwitchToSearchTab)}
        />
      </form>
      <div
        className={classnames('side-bar-toolbar-button', { active: isSettingsTabActive })}
        {...onClickGenerator(onToggleSettingsTab)}
      >
        <i className="fa fa-cog" />
      </div>
      <ReloadButton
        autoReloadEnabled={autoReloadEnabled}
        isReloading={isReloading}
        onReload={onReload}
      />
    </div>
  );
}
